import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { ContentService } from '@blk/cwp-ng-framework';
import { CellData } from '@ddt-web/data-service';

import { ScenarioService } from '../../services/scenario.service';
import { ScenarioCategoryUtil } from '../../utils/scenario-category.util';

@Component({
	selector: 'sc-scenario-category',
	templateUrl: './scenario-category.component.html',
	styleUrls: ['./scenario-category.component.scss']
})
export class ScenarioCategoryComponent implements OnInit {
	@Input() public scenarios: CellData[];
	@Input() public category: string;
	@Input() public selectedScenarios: string[] = [];
	@Input() public featuredScenarioStrings: string[] = [];
	@Input() public showInfoBubbles: boolean = false;
	@Output() public onSelect: EventEmitter<any> = new EventEmitter<any>();
	@Output() public onDeselect: EventEmitter<any> = new EventEmitter<any>();

	public categoryName: string;
	public categoryImagePath: SafeUrl;

	constructor(private scenarioService: ScenarioService, private contentService: ContentService) { }

	public ngOnInit(): void {
		this.categoryName = ScenarioCategoryUtil.getCategoryName(this.category, this.contentService);
		this.categoryImagePath = this.scenarioService.getImagePath(this.category);
	}

	public updateSelect(scenarioId: string, option: string): void {
		if (option === 'SELECT') {
			this.onSelect.emit(scenarioId);
		} else if (option === 'DESELECT') {
			this.onDeselect.emit(scenarioId);
		}
	}

	public isSelected(id: string): boolean {
		return this.selectedScenarios.includes(id);
	}

	public isFeatured(id: string): boolean {
		return this.featuredScenarioStrings && this.featuredScenarioStrings.includes(id);
	}

}
